var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStogoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 325.692,
    height: 105.293,
    viewBox: "0 0 325.692 105.293",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 325.692,
    height: 105.293,
    transform: "translate(0 1)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 325.692,
    height: 105.293,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 324.326,
    height: 103.927,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 303.272,
    height: 13.526,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M16.687,124.944l8.041,13.526h7.042l-8.041-13.526Z",
    transform: "translate(-16.687 -124.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.756,
    y1: 1.474,
    x2: -0.711,
    y2: 1.474,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbf7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f07168"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M38.888,124.944l8.041,13.526h7.042L45.93,124.944Z",
    transform: "translate(-38.888 -124.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1.761,
    y1: 1.474,
    x2: -1.716,
    y2: 1.474,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M61.089,124.944l8.042,13.526h7.042l-8.041-13.526Z",
    transform: "translate(-61.089 -124.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.767,
    y1: 1.474,
    x2: -2.722,
    y2: 1.474,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M83.291,124.944l8.042,13.526h7.041l-8.04-13.526Z",
    transform: "translate(-83.291 -124.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3.773,
    y1: 1.474,
    x2: -3.727,
    y2: 1.474,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M105.493,124.944l8.041,13.526h7.042l-8.042-13.526Z",
    transform: "translate(-105.493 -124.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -4.778,
    y1: 1.474,
    x2: -4.733,
    y2: 1.474,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M127.694,124.944l8.041,13.526h7.042l-8.041-13.526Z",
    transform: "translate(-127.694 -124.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -5.784,
    y1: 1.474,
    x2: -5.738,
    y2: 1.474,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M149.9,124.944l8.041,13.526h7.042l-8.041-13.526Z",
    transform: "translate(-149.895 -124.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -6.789,
    y1: 1.474,
    x2: -6.744,
    y2: 1.474,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M172.1,124.944l8.041,13.526h7.042l-8.041-13.526Z",
    transform: "translate(-172.097 -124.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -7.795,
    y1: 1.474,
    x2: -7.75,
    y2: 1.474,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M193.452,124.944l8.042,13.526h7.042l-8.041-13.526Z",
    transform: "translate(-193.452 -124.944)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -8.762,
    y1: 1.474,
    x2: -8.717,
    y2: 1.474,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.683 0.683)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M316.824,11.538H169.519L149.358,1H49.431L29.269,11.538H9.5a8.5,8.5,0,0,0-8.5,8.5V96.424a8.5,8.5,0,0,0,8.5,8.5H316.824a8.5,8.5,0,0,0,8.5-8.5V20.041a8.5,8.5,0,0,0-8.5-8.5",
    transform: "translate(-1 -1)",
    fill: "#00a2ac"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(11.4 85.361)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M31.77,138.469H24.728l-8.041-13.526h7.042Z",
    transform: "translate(-16.687 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M53.972,138.469H46.929l-8.041-13.526H45.93Z",
    transform: "translate(-23.72 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M76.173,138.469H69.131l-8.041-13.526h7.042Z",
    transform: "translate(-30.754 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M98.374,138.469H91.332l-8.041-13.526h7.042Z",
    transform: "translate(-37.787 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M120.576,138.469h-7.042l-8.041-13.526h7.042Z",
    transform: "translate(-44.821 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M142.777,138.469h-7.042l-8.042-13.526h7.042Z",
    transform: "translate(-51.855 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M164.978,138.469h-7.042l-8.041-13.526h7.042Z",
    transform: "translate(-58.888 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M187.18,138.469h-7.042L172.1,124.944h7.042Z",
    transform: "translate(-65.922 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M209.381,138.469h-7.042L194.3,124.944h7.042Z",
    transform: "translate(-72.955 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M231.583,138.469H224.54L216.5,124.944h7.042Z",
    transform: "translate(-79.989 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M253.784,138.469h-7.042L238.7,124.944h7.042Z",
    transform: "translate(-87.022 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M275.986,138.469h-7.042L260.9,124.944h7.042Z",
    transform: "translate(-94.056 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M298.187,138.469h-7.042L283.1,124.944h7.042Z",
    transform: "translate(-101.09 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M320.388,138.469h-7.042L305.3,124.944h7.042Z",
    transform: "translate(-108.123 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M342.59,138.469h-7.042l-8.041-13.526h7.042Z",
    transform: "translate(-115.157 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M364.791,138.469h-7.042l-8.041-13.526h7.042Z",
    transform: "translate(-122.19 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M386.992,138.469H379.95l-8.041-13.526h7.042Z",
    transform: "translate(-129.224 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M409.194,138.469h-7.042l-8.041-13.526h7.042Z",
    transform: "translate(-136.257 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M431.4,138.469h-7.042l-8.041-13.526h7.042Z",
    transform: "translate(-143.291 -124.944)",
    fill: "#c1c1c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M453.6,138.469h-7.042l-8.041-13.526h7.042Z",
    transform: "translate(-150.324 -124.944)",
    fill: "#c1c1c0"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M316.824,11.538H169.519L149.358,1H49.431L29.269,11.538H9.5a8.5,8.5,0,0,0-8.5,8.5V96.424a8.5,8.5,0,0,0,8.5,8.5H316.824a8.5,8.5,0,0,0,8.5-8.5V20.041A8.5,8.5,0,0,0,316.824,11.538Z",
    transform: "translate(-0.317 -0.317)",
    fill: "none",
    stroke: "#00a2ac",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(11.4 85.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 15.084,
    height: 13.526,
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(26.568 85.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 15.084,
    height: 13.526,
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(41.736 85.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 15.084,
    height: 13.526,
    transform: "translate(0)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16",
    transform: "translate(56.904 85.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 15.083,
    height: 13.526,
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    transform: "translate(72.072 85.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 15.084,
    height: 13.526,
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(87.24 85.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    width: 15.084,
    height: 13.526,
    transform: "translate(0)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(102.407 85.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 15.084,
    height: 13.526,
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(117.575 85.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 15.083,
    height: 13.526,
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(132.165 85.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 15.084,
    height: 13.526,
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_13626",
    "data-name": "Path 13626",
    d: "M10.955-20.2a2.782,2.782,0,0,0-1.837.6A2.1,2.1,0,0,0,8.4-17.885a2.473,2.473,0,0,0,.665,1.8,4.344,4.344,0,0,0,1.732,1.05q1.068.367,2.38.7a26.818,26.818,0,0,1,2.607.805,11.44,11.44,0,0,1,2.362,1.173,5.138,5.138,0,0,1,1.733,1.977,6.557,6.557,0,0,1,.665,3.062,6.86,6.86,0,0,1-2.537,5.338A9.779,9.779,0,0,1,11.323.245a10.508,10.508,0,0,1-6.685-2A6.792,6.792,0,0,1,2.1-7.42H8.47q.245,2.94,3.01,2.94a2.868,2.868,0,0,0,2.03-.682,2.261,2.261,0,0,0,.735-1.733A2.321,2.321,0,0,0,13.58-8.61a4.625,4.625,0,0,0-1.733-1.05q-1.068-.385-2.38-.717A24.061,24.061,0,0,1,6.86-11.2,12.742,12.742,0,0,1,4.5-12.373a5,5,0,0,1-1.732-1.96A6.475,6.475,0,0,1,2.1-17.36a6.709,6.709,0,0,1,2.555-5.495,10.053,10.053,0,0,1,6.527-2.065,10.579,10.579,0,0,1,6.423,1.8q2.45,1.8,2.555,5.688H13.65a3.281,3.281,0,0,0-.857-2.048A2.488,2.488,0,0,0,10.955-20.2Zm12.635.175v-4.55H42.98v4.55H36.26V0H30.275V-20.02ZM62.4-7.21a7.266,7.266,0,0,0,1.785-5.145A7.31,7.31,0,0,0,62.423-17.5,6.1,6.1,0,0,0,57.7-19.425,6.1,6.1,0,0,0,52.972-17.5,7.31,7.31,0,0,0,51.2-12.355,7.31,7.31,0,0,0,52.972-7.21,6.1,6.1,0,0,0,57.7-5.285,6.049,6.049,0,0,0,62.4-7.21ZM48.755-3.325a12.115,12.115,0,0,1-3.64-9.03,12.028,12.028,0,0,1,3.658-9.012,12.371,12.371,0,0,1,8.96-3.553,12.253,12.253,0,0,1,8.925,3.553,12.088,12.088,0,0,1,3.622,9.012,12.115,12.115,0,0,1-3.64,9.03A12.258,12.258,0,0,1,57.715.245,12.377,12.377,0,0,1,48.755-3.325Zm27.58,0a12.115,12.115,0,0,1-3.64-9.03,12.028,12.028,0,0,1,3.658-9.012,12.35,12.35,0,0,1,8.942-3.553,12.622,12.622,0,0,1,7.28,2.17,11.311,11.311,0,0,1,4.445,6.02H89.88a4.7,4.7,0,0,0-4.48-2.7A6.254,6.254,0,0,0,80.552-17.5a7.31,7.31,0,0,0-1.768,5.145A7.31,7.31,0,0,0,80.552-7.21a6.125,6.125,0,0,0,4.743,1.925,5.439,5.439,0,0,0,3.482-1.068A5.144,5.144,0,0,0,90.58-9.2H83.65v-4.55H97.02V-9.2A11.957,11.957,0,0,1,93.345-2.94,11.071,11.071,0,0,1,89.792-.665a11.66,11.66,0,0,1-4.5.875A12.442,12.442,0,0,1,76.335-3.325Zm40.39-3.885a7.266,7.266,0,0,0,1.785-5.145,7.31,7.31,0,0,0-1.767-5.145,6.1,6.1,0,0,0-4.725-1.925,6.1,6.1,0,0,0-4.725,1.925,7.31,7.31,0,0,0-1.768,5.145,7.31,7.31,0,0,0,1.768,5.145,6.1,6.1,0,0,0,4.725,1.925A6.049,6.049,0,0,0,116.725-7.21Zm-13.65,3.885a12.115,12.115,0,0,1-3.64-9.03,12.028,12.028,0,0,1,3.658-9.012,12.371,12.371,0,0,1,8.96-3.553,12.253,12.253,0,0,1,8.925,3.553,12.088,12.088,0,0,1,3.623,9.012,12.115,12.115,0,0,1-3.64,9.03,12.258,12.258,0,0,1-8.925,3.57A12.377,12.377,0,0,1,103.075-3.325Z",
    transform: "translate(100.108 61.972)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStogoLogo);
export default __webpack_public_path__ + "static/media/stogo-logo.51124f19473b779366466af5dff290d3.svg";
export { ForwardRef as ReactComponent };